import Main from "./Main.svelte";

function initDemoDashboard(wrapId, params = {}) {
	return new Main({
		target: document.getElementById(wrapId),
		props: params
	});
}

window.initDemoDashboard = initDemoDashboard;